import {APIError} from 'data/errors';

export function formatApiErrorResponse(error: APIError) {
	if (typeof error.message === 'string' && error.message.startsWith('{')) {
		const parsedResponse = JSON.parse(error.message);
		return parsedResponse.error.invalidParams.reason;
	}
	if (Array.isArray(error.message)) {
		return error.message[0].msg;
	}
	return error.message;
}
